module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter2"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block7"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Olive")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p118"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("I")]), _vm._v(" lean back in my chair, tapping a pencil against my lips. The white decor of the office is usually soothing, the bright pops of yellow and blue dazzling my brain just enough to spur the creative juices that are nearly always flowing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p119"
    }
  }, [_vm._v("Work is the only place where I let my bubble of control deflate, because there’s freedom in creativity I can’t find anywhere else. Staring down at the sketch, my eyes drink in the bold lines mixing with the softer curves of a residential master bedroom. The measurements of the room are massive, the home a classic Victorian in downtown Wilmington. It’s a nice change from the oceanic homes that serve as the bread and butter of the design house. Becoming a partner here six months ago was exactly according to my plan; I always knew I wanted to be a full partner at Eisengard Interiors—now Eisengard & Alexander Interiors—by age thirty, and I beat my own deadline by a year.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p120"
    }
  }, [_vm._v("My life is on track. At least, it "), _c('i', [_vm._v("was")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p121"
    }
  }, [_vm._v("My phone chimes from the top of the desk, and I pick it up. Irritation prickles me from the unexpected distraction. My coworkers, my partner Beth Eisengard and my friend Berkeley Conners, will both be in the office today, and my sister and her new husband are soaking up the sun in Aruba by now. So who’s texting me?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p122"
    }
  }, [_vm._v("Glancing at the screen, I exhale. "), _c('i', [_vm._v("Of course. I should have known.")])]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "extract1"
    }
  }, [_c('p', {
    staticClass: "ext1-rw",
    attrs: {
      "id": "p123"
    }
  }, [_c('b', [_vm._v("Ken: Dinner tonight?")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p124"
    }
  }, [_vm._v("I’ve been on exactly four dates with Ken. We met at a client mixer that my firm hosts a few times a year. Ken Hart, a litigator for a prestigious law firm here in Wilmington, asked me to dinner that night after speaking with me for merely a few minutes. Flattered, I accepted.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p125"
    }
  }, [_vm._v("Since then, Ken scheduled dates. They all took place before I left for Paris four months ago, and I had no idea if he’d want to continue seeing me when I returned. I texted him last night to let him know I was home, and apparently now I have my answer.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p126"
    }
  }, [_vm._v("I hesitate, my mind wandering as my fingers absently hover over the keys. But instead of Ken, I picture tanned olive skin, dark hair just long enough on top for a woman to run her fingers through and shaved close on the sides, and the deepest, brightest pair of green eyes I’ve ever seen. A strong jaw covered in stubble, like he only shaves every few days and couldn’t care less about it. Thick, corded biceps that flex with every small movement, and a rare smile that lights up an entire room whenever he uses it. His serious, intense expression, which normally graces his chiseled face, is the one that I usually see, and it’s just as intriguing, if not more so, than his smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p127"
    }
  }, [_c('i', [_vm._v("Ronin Shaw.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p128"
    }
  }, [_vm._v("He’s "), _c('i', [_vm._v("not")]), _vm._v(" my type.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p129"
    }
  }, [_vm._v("Honestly, he’s so far from my type it’s almost laughable. Ronin Shaw is way too unpredictable, much too impenetrable, and…generally too much to handle. He’s the kind of man you have a one-night stand with, not the kind of man you date. Not that he’d even be interested in that when it comes to me. Nor am I interested in one-night stands.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p130"
    }
  }, [_vm._v("Remembering the phone in my hand and shaking my head to clear it, I send a quick text back to Ken. Date number five. This means I’ll let him come inside after he drops me off from dinner. The thought doesn’t send tingles of lust dancing along my skin the way it should. But then again, have I ever felt tingles of lust dancing along my skin?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p131"
    }
  }, [_c('i', [_vm._v("Yes. ")]), _vm._v("But only when thoughts of a certain tall, dark, and gorgeous ex-soldier pop into my head.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p132"
    }
  }, [_vm._v("Ignoring that thought, I press send.")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "extract2"
    }
  }, [_c('p', {
    staticClass: "ext1-rw",
    attrs: {
      "id": "p133"
    }
  }, [_c('b', [_vm._v("Me: I’d love to. Pick me up from the office at five thirty.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p134"
    }
  }, [_c('i', [_vm._v("I’ll be in bed by ten.")]), _vm._v(" I slide my phone to the corner of my desk and frown. Usually after scheduling a date with Ken, I’m satisfied. Ken is the kind of man I’ve always pictured having by my side in the life I’ve built, and our dates have been going well. He’s polite and well mannered, thoughtful, and controlled. Just the way I like my men.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p135"
    }
  }, [_vm._v("But right now? I can’t muster up an ounce of excitement for tonight.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p136"
    }
  }, [_c('i', [_vm._v("Not, a big deal. When I see Ken, the way he makes me feel will rekindle. It’ll be a great night.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p137"
    }
  }, [_vm._v("Of course it will.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p138"
    }
  }, [_vm._v("A knock on the doorway pulls me from my thoughts and I look up. The firm boasts a gigantic workspace, and we’ve separated the offices from the generous front lobby with glass partitions. There are no doors, something Beth thought would help the creativity flow freely around the place. I tend to agree, but today I’d really like a door to close and a solid wooden wall to hide behind while I try to figure out why the wrinkles in my life just keep getting bigger.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p139"
    }
  }, [_vm._v("Instead, I plaster on a smile for my friend. “Hi, Berkeley.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p140"
    }
  }, [_vm._v("She saunters into the office, looking like my perfect opposite in every single way. Berkeley is definitely a free spirit. Her creativity shines through every aspect of her being, and she’s like a walking ray of sunshine. Wild, long blond hair she wears curly, and deep, soulful tawny eyes. Right now, her round, pretty face is looking at me with concern.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p141"
    }
  }, [_vm._v("“Are you okay?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p142"
    }
  }, [_vm._v("Forcing my smile to grow, I nod. “Of course. Did you have fun at the wedding?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p143"
    }
  }, [_vm._v("She tilts her head to the side, her curls quivering as she studies me. I keep the smile pasted on my face, knowing I can fake it till I make it until the sun goes down if I need to.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p144"
    }
  }, [_vm._v("Finally, she nods, but her clever eyes never stop assessing me. “It was beautiful and just the most romantic thing ever. I mean, seriously…a "), _c('i', [_vm._v("surprise wedding")]), _c('i', [_vm._v("?")]), _c('i'), _vm._v("Who does that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p145"
    }
  }, [_vm._v("My smile turns softer and it’s 100 percent real. “The guy who’s been waiting a long time for a second chance with my sister, that’s who.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p146"
    }
  }, [_vm._v("Berkeley’s lips pull into a dreamy grin. “Yeah.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p147"
    }
  }, [_vm._v("We both fall silent for a minute, our minds most likely traveling in different directions. Berkeley’s is probably on a train full of love stories, while I’m on a trip straight back to reality. I know that there’s nothing in the world less possible to control than love. Which means I want no part of it. What I want is security, safety. Two things I need more than romance or happily-ever-after. Two things I can "), _c('i', [_vm._v("control ")]), _vm._v("without messy emotions getting in the way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p148"
    }
  }, [_vm._v("“Anyway.” Berkeley perks up, her gaze brightening again. “I just wanted to say welcome back. I missed you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p149"
    }
  }, [_vm._v("She really is a sweetheart. Lacing my fingers together, I rest my chin on my propped hands. “I missed you, too, Berkeley. Happy to be home and back in the office.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p150"
    }
  }, [_vm._v("One eyebrow arches as she regards me. “Really? Not missing the glamorous Parisian life? I know old Mrs. Dubois was a class act, and you spent a lot of time with her at the end.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p151"
    }
  }, [_vm._v("The compassion in Berkeley’s eyes takes me straight back there, to the rambling chateau at the edge of the city where Clara Dubois had made her home. I had no idea she was dying when I’d made the commitment to move to Paris for a few months in order to design the gorgeous estate, but she and I had become impossibly close during that time. Maybe it was the fact that I was estranged from my own righteous, intolerant parents, or maybe she saw something in me that mirrored her need to seize control in her own life. Either way, we’d clicked and the loss of her at the end of my time in Paris still aches.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p152"
    }
  }, [_vm._v("For Berkeley, I shake my head. “Nope. I left Paris behind and am totally back in the swing of things here.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p153"
    }
  }, [_vm._v("Berkeley shoves a thick chunk of her wild curls off of her face. “You’re starting the new project on the boutique hotel in Wrightsville Beach today, right?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p154"
    }
  }, [_vm._v("Nodding, I glance down at the organized chaos of my desk. “And also the traditional Victorian inn downtown.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p155"
    }
  }, [_vm._v("Berkeley’s face lights up. “That one is close to Jeremy and Rayne’s place.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p156"
    }
  }, [_vm._v("I smile. “Yes, and I’m looking forward to both jobs. But the Victorian is going to be especially fun.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p157"
    }
  }, [_vm._v("She nods knowingly. “Right up your alley.” She turns, rapping her knuckles lightly on the glass beside the open doorway. “Let me know if you need anything.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p158"
    }
  }, [_vm._v("Shaking my head, my gaze drifts back down to the sketch I’m working on. “Our assistant designer is going to help on both of these, so I’m all set. I know you have your own work to do.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p159"
    }
  }, [_vm._v("It’s true, even though Berkeley is five years my junior and not a partner in the firm, she’s a capable and creative designer and often heads up her own projects these days. She nods, gives me a wave, and heads down the hall.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p160"
    }
  }, [_vm._v("An hour after lunch, our design assistant Paisley and I climb out of my little silver BMW in front of the Whisper Hill Inn. I stare up at it, appreciating the eye-catching architecture. I’d taken on this project because, after my abrupt return from Paris, I wanted something to throw myself into at work. This project is daunting because it’s not my usual style. It’s going to be a challenge, and that’s exactly what I need in my life right now.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p161"
    }
  }, [_vm._v("A distraction.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p162"
    }
  }, [_vm._v("Paisley catches her breath as she steps up beside me. “It’s beautiful.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p163"
    }
  }, [_vm._v("Nodding, I don’t take my eyes off the old Victorian inn.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p164"
    }
  }, [_vm._v("“It is. Now let’s get to work.”")]), _vm._v(" "), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line3"
    }
  }, [_c('p', {
    attrs: {
      "id": "p165"
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p166"
    }
  }, [_vm._v("By the time Paisley and I make it back to the office, it’s after five.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p167"
    }
  }, [_vm._v("“I’m glad we have three months to get this place done.” It’s the first thing Paisley has said since we left the hotel, and she sounds more than overwhelmed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p168"
    }
  }, [_vm._v("I offer her a smile. “First commercial project, right?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p169"
    }
  }, [_vm._v("She nods, biting her lip.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p170"
    }
  }, [_vm._v("We’d hired Paisley as a design assistant just before I left for Europe. “You did great today, Paisley. You asked a lot of good questions about what the client wants, and we got a good feel for the essence of the building. Now comes the fun part. First thing in the morning we’ll powwow, okay?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p171"
    }
  }, [_vm._v("We’ve stopped outside the glass that separates my office from the hall, and Paisley is staring inside. Following her awestruck gaze, my heart stutters to a near stop before I inhale and force it to begin beating again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p172"
    }
  }, [_vm._v("He’s standing by the windows behind my desk, but even from the back I know exactly who it is. His gray long-sleeved thermal stretches tight across his broad shoulders and wide, muscular back. As we watch him, he reaches up absently to drag a hand through the messed-up locks on top of his head before allowing it to run down the shaved back and rests on his neck. I let my eyes travel south, past his narrow, trim waist, and they stop briefly on the perfect ass that fills out a pair of perfectly fitted jeans. No skinny jeans for Ronin Shaw. Hell, no. This guy…he’s all-man. The fact that I’m usually attracted to men who shave every morning and wear tailored suits at all hours of the day makes it even more glaringly obvious that something about Ronin, whether I want to admit it or not, just "), _c('i', [_vm._v("does it for me.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p173"
    }
  }, [_vm._v("As if he senses our heated gazes on his back, Ronin turns to face us, his big hand still gripping the back of his neck. His eyes skate over Paisley but then they fix to mine and stay there. His stare is so intensely focused as it sweeps down my body and back again, I feel like he’s touched me intimately while standing ten feet away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p174"
    }
  }, [_vm._v("Paisley catches her breath next to me, and I glance at her before clearing my throat and entering the office. “Um, hi. Ronin?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p175"
    }
  }, [_vm._v("And that’s it. Those are all the words I have. "), _c('i', [_vm._v("Brilliant, Olive.")]), _vm._v(" But seriously, why is he here? I didn’t even know he knew where I worked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p176"
    }
  }, [_vm._v("“So,” I say too loudly, turning toward my assistant. “Yeah, thanks, Paisley. See you in the morning.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p177"
    }
  }, [_vm._v("She rips her eyes off of Ronin long enough to give me an approving smirk. “Yes, Ms. Alexander. See you in the morning. Have a good night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p178"
    }
  }, [_vm._v("She practically giggles as she heads down the hallway, and I close my eyes briefly to gather myself before focusing my attention on the man standing beside my desk.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p179"
    }
  }, [_vm._v("I force my legs to work properly, noticing that they’re feeling pretty rubbery and ineffective at the moment. I walk toward my desk, my laptop bag feeling suddenly very heavy on my shoulder. As I shrug it off, Ronin catches it and sets it gently on my desk.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p180"
    }
  }, [_vm._v("“Thanks.” My voice is a little bit breathless, and the way his eyes travel over my body again is making my skin feel heated. “Hey.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p181"
    }
  }, [_vm._v("His lips twitch into an almost smile, but then I see a genuine smile light up his eyes. Ronin’s eyes are extremely expressive, and as I stare into them I notice not for the first time that they’re the most interesting shade of green I’ve ever seen. They’re a super-light sage, with flecks of amber and gold swimming in the irises. Contrasted with his darkly tanned skin and his obviously exotic features, his face is almost a work of art. Strong jaw covered in scruff, chiseled cheekbones; dark, long lashes are the picture of perfection. But a forehead that’s just a little bit too broad, and a nose that’s just slightly crooked add notes of imperfection that complete the masterpiece in the most intriguing way I’ve ever encountered.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p182"
    }
  }, [_vm._v("He swallows, and my eyes fall to the movement of his Adam’s apple. That’s when I know I’ve probably been staring at his face a little too long. "), _c('i', [_vm._v("Thank God his shirt’s on. There’s no way I’d be able to tear my eyes from the muscles I know are under it.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p183"
    }
  }, [_vm._v("Inhaling, I try to focus. On the words. That need to be said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p184"
    }
  }, [_vm._v("“Hey. Busy day?” His voice is somehow rough like lava rocks and smooth like Brazilian coffee all at the same time. It rushes over me, leaving goose bumps on my skin.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p185"
    }
  }, [_vm._v("Nodding, I round my desk and pick up a stack of papers for absolutely no reason. I shuffle them in my hands and place them back down again. "), _c('i', [_vm._v("What is wrong with me?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p186"
    }
  }, [_vm._v("I know exactly what’s wrong with me. Ronin Shaw is in my office, in my personal space. My personal space is off-limits, because his presence is far too large to be contained in here. “Can I help you with something, Ronin?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p187"
    }
  }, [_vm._v("One thick black eyebrow lifts, and his full lips draw into a slow smile. “Yeah. There’s something I want to run by you. I came to take you to dinner.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p188"
    }
  }, [_vm._v("My jaw goes slack as I stare at him. Remembering to close it, I suck in a deep breath and raise myself up to my full five foot seven. Add in the height from my heels and I’m on the taller side, but it doesn’t matter when I’m still looking up at a man who’s at least six three. “I can’t.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p189"
    }
  }, [_vm._v("His expression doesn’t change. “Sure you can.” He leans a hip on the side of my desk and just watches me while I attempt to give him a stern look.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p190"
    }
  }, [_vm._v("I’ve perfected the look over the years. It works on absolutely everyone, informing them that I mean business and I’m not someone to be trifled with.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p191"
    }
  }, [_vm._v("But Ronin just smirks through it, like my stern look doesn’t affect him at all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p192"
    }
  }, [_vm._v("“No, I really can’t, Ronin. I have plans.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p193"
    }
  }, [_vm._v("That gets his attention. Three little lines appear in his forehead as his brows pull together, and his mouth screws to the side while he asses me with that serious gaze. “On a Monday night?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p194"
    }
  }, [_vm._v("A knock on the glass causes both our glances to dart toward the doorway. Ken stands there, hesitating at the entrance as he takes in Ronin and me. I let out a sigh of relief, because Ken in my office makes perfect sense, whereas Ronin in my office does not.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p195"
    }
  }, [_vm._v("Ken wanders in, pulling his platinum wristwatch in front of his face to check the time. He gives me a pointed look. “We have a reservation for six, Olive.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p196"
    }
  }, [_vm._v("I thought I had perfected my stern look? Ken’s makes mine look like puppy-dog-eyes. He stops a few feet in front of Ronin, who remains perched on the side of my desk. “Ken Hart. You are?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p197"
    }
  }, [_vm._v("Ronin glances at Ken’s outstretched hand, which I can’t help but notice is much smaller than Ronin’s. Actually, everything about Ronin dwarfs Ken, now that they’re side by side. And the differences between them are marked. From Ken’s artfully styled blond hair, to his gray pinstriped Thom Browne suit.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p198"
    }
  }, [_vm._v("Ken is a fit, healthy guy. He’s handsome. He’s successful. But right now, as I evaluate him beside Ronin, all of that pales beside the other man.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p199"
    }
  }, [_vm._v("Finally, Ronin stands and grasps Ken’s hand in his. “Ronin Shaw.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p200"
    }
  }, [_vm._v("That’s all he offers, and Ken’s shrewd expression darkens slightly. He glances at me. “Ready to go?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p201"
    }
  }, [_vm._v("On the inside, I sigh. On the outside, I give Ken a faint smile. “Meet you in the lobby in just a minute.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p202"
    }
  }, [_vm._v("He glances at his watch "), _c('i', [_vm._v("again")]), _c('i', [_vm._v(",")]), _vm._v(" and then at Ronin. Dipping his chin at the other man before he exits, he disappears from the office in a cloud of expensive cologne.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("I begin gathering my things.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("Ronin chuckles, and I look over at him. “His actual name is Ken?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("Pausing, I stand up straight and rest my hands on my hips. “Why are you really here, Ronin?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("His hand returns to the back of his neck, gripping it tightly. His tone grows slightly chilly. “You know? I don’t really know why. My friend married your sister, and I just thought I would check in on you while they’re gone.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("Staring at him, I narrow my eyes. “Are you serious right now? I’m a big girl, and I’m more than capable of taking care of myself.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("I can hear that haughty tone in my voice, but I can’t stop it. I don’t know who Ronin Shaw thinks he is, but he’s not my protector and I’m not his problem.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("I have problems of my own to worry about. My thoughts stray and my stomach clenches.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("“So, thanks for stopping by.” I walk toward my corner cabinet and open the door, taking out my fall trench coat and putting it on. Grabbing hold of my laptop case and my purse, I give Ronin a pointed glance.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("“Anything else?”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3d7ccc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s006-Chapter-002.vue
// module id = 75
// module chunks = 0